export default __webpack_public_path__ + "static/media/back.99a721ae.svg";